<template>
  <div>
    <div class="main">
      <div class="form-row-parse">
        <div class="form-input-parse">
          <label for="file">КПТ XML</label>
          <input
            type="file"
            id="file"
            ref="file"
            v-on:change="handleFileUpload"
          />
        </div>
        <div class="form-button-parse" v-show="!waite">
          <button v-on:click="submitFile" class="add" v-show="!complete">
            Загрузить
          </button>
        </div>
        <div class="form-button-parse">
          <router-link class="clear" to="/admin/map/addvillage/2">
            <span>Пропустить</span>
          </router-link>
        </div>
        <div class="form-button-parse" v-show="cadastrData">
          <button v-on:click="add" class="add" v-show="!waite">
            Добавить в базу
          </button>
        </div>
        <div class="form-button-parse" v-show="complete">
          <router-link class="clear" to="/admin/map/addvillage/2">
            <span>Продолжить</span>
          </router-link>
        </div>
        <img v-show="waite" src="@/assets/wait.gif" class="waite" alt="" />
        <div v-show="info">{{ info }}</div>
      </div>
    </div>
    <div>
      <yandex-map
        map-type="hybrid"
        :coords="coordsCenter"
        :zoom="12"
        :controls="[]"
      >
        <ymap-marker :coords="coords" marker-id="123" />
        <ymap-marker
          v-for="(item, index) in plants"
          :coords="item.coordinates"
          :marker-type="item.type"
          :options="overlayPlant"
          :marker-id="index"
          v-bind:key="index + 'plant'"
        />
      </yandex-map>
    </div>
  </div>
</template>

<script>
import config from "@/config";
import { yandexMap, ymapMarker } from "vue-yandex-maps";
import axios from "axios";

export default {
  name: "AddVillageCoord",
  components: { yandexMap, ymapMarker },
  data() {
    return {
      file: "",
      waite: false,
      complete: false,
      info: null,
      url: config.backend_url,
      coords: [55.755819, 37.617644],
      coordsCenter: [55.755819, 37.617644],
      cadastrData: false,
      plants: [],
      overlayPlant: {
        fillColor: "#307c0d",
        strokeColor: "#fcfcfc",
        fillOpacity: 0.5,
        strokeWidth: 1
      }
    };
  },
  computed: {},
  methods: {
    submitFile() {
      let formData = new FormData();
      let self = this;
      self.info = null;
      self.waite = true;
      formData.append("file", this.file);
      formData.append("token", this.$store.state.auth.token);
      axios
        .post(this.url + "cadastr/parse-xml", formData, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        })
        .then(function(res) {
          let data = res.data;
          if (data.error) {
            self.info = data.error;
          } else {
            self.cadastrData = data;
            let elementsData = [];
            let coordsCenter = self.coordsCenter;

            for (const [key, value] of Object.entries(data)) {
              let coord = JSON.parse(value.COORDINATES);
              let data = JSON.parse(value.DATA);
              let valueCoord = {};
              valueCoord.name = value.CADASTR;
              valueCoord.data = data;
              valueCoord.type = "Polygon";
              valueCoord.id = parseInt(value.ID);
              valueCoord.coordinates = [];
              valueCoord.coordinates.push(coord);
              elementsData.push(valueCoord);
              coordsCenter = coord[0];
            }

            console.log(elementsData);
            self.coordsCenter = coordsCenter;
            self.plants = elementsData;
          }
          self.waite = false;
        })
        .catch(function(res) {
          console.log(res);
        });
    },
    handleFileUpload() {
      this.file = this.$refs.file.files[0];
    },
    add: function() {
      let self = this;
      self.waite = true;
      let data = {
        url: self.url + "cadastr/add",
        data: self.cadastrData,
        method: "POST"
      };
      this.$store.dispatch("query/sendRequest", data).then(function(response) {
        let data = response.data;
        console.log(data);
        if (!data.error) {
          self.info = "Данные добавлены!";
          self.cadastrData = false;
          self.waite = false;
          self.complete = true;
        }
      });
    }
  },
  created() {}
};
</script>

<style scoped></style>
